import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getBoxesTemplates = createAsyncThunk(
  'boxTemplate/getBoxesTemplates',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/four_boxes_templates`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveBoxTemplate = createAsyncThunk(
  'boxTemplate/saveBoxTemplate',
  async ({ name, isUpdate }, { getState, rejectWithValue }) => {
    try {
      let response;
      const data = {
        name,
      };
      if (isUpdate.state) {
        response = await securedAxiosInstance.put(
          `/four_boxes_templates/${isUpdate.template.id}`,
          data
        );
      } else {
        response = await securedAxiosInstance.post(
          `/four_boxes_templates`,
          data
        );
      }

      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteBoxTemplate = createAsyncThunk(
  'boxTemplate/deleteBoxTemplate',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.delete(
        `/four_boxes_templates/${id}`
      );
      return { ...response, id };
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getCategoryTemplates = createAsyncThunk(
  'boxTemplate/getCategoryTemplates',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/goal_category_templates`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateCategory = createAsyncThunk(
  // action type string
  'boxTemplate/updateCategory',
  // callback function
  async ({ templateId, goalCategoryId, title, tooltip }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.put(
        `/goal_category_templates/${goalCategoryId}`,
        {
          four_boxes_template_id: templateId,
          title: title,
          tool_tip: tooltip,
        }
      );
      return { ...result.data, templateId };
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const getGoalTemplates = createAsyncThunk(
  'boxTemplate/getGoalTemplates',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/goal_templates`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveGoalTemplate = createAsyncThunk(
  'boxTemplate/saveGoalTemplate',
  async (
    { goalItem, goalCategoryTemplateId, templateId, isCreating, id },
    thunkApi
  ) => {
    try {
      let response;
      if (isCreating) {
        response = await securedAxiosInstance.post('goal_templates', {
          text: goalItem,
          goal_category_template_id: goalCategoryTemplateId,
        });
      } else {
        response = await securedAxiosInstance.put(`goal_templates/${id}`, {
          text: goalItem,
          goal_category_template_id: goalCategoryTemplateId,
        });
      }

      return {
        ...response.data,
        templateId,
        goalCategoryTemplateId,
        isCreating,
      };
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const deleteGoalTemplate = createAsyncThunk(
  // action type string
  'boxTemplate/deleteGoalTemplate',
  // callback function
  async ({ id, category, templateId }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.delete(`/goal_templates/${id}`);
      return { ...result.data, category, templateId, goalId: id };
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);
